import React from 'react';
import { ChevronDown } from 'lucide-react';
export function ContentMapSection() {
  const chapters = ['Introducción: La Cama de Hospital', 'Capítulo 1: El Mecanismo Silencioso', 'Capítulo 2: Identificando las Señales', 'Capítulo 3: La Trampa del Supermercado Americano', 'Capítulo 4: El Protocolo y Plan de 14 Días', 'Bonus: Guía de Rescate de Emergencia'];
  return <section className="py-20 px-4 bg-[#141414]" data-id="element-14">
      <div className="max-w-2xl mx-auto" data-id="element-15">
        <h2 className="text-2xl md:text-3xl font-serif text-center text-white mb-10" data-id="element-16">
          Qué hay dentro (mapa rápido)
        </h2>

        <div className="space-y-3" data-id="element-17">
          {chapters.map((chapter, idx) => <div key={idx} className="bg-[#1a1a1a] p-4 rounded-lg border border-[#2a2a2a] flex items-center justify-between" data-id="element-18">
              <span className="text-[#ccc] font-medium" data-id="element-19">{chapter}</span>
              <ChevronDown className="w-4 h-4 text-[#555]" data-id="element-20" />
            </div>)}
        </div>
      </div>
    </section>;
}